import { SAGA_ACTIONS } from '../../../_config'
import { ErrorResponse, SuccessResponse } from '../apiTypes'
import { useApiCall } from '../appApiCallHook'

export function useBlockingFactorApi() {
    const callApi = useApiCall()

    const getBlockingFactors = <P, R>(data: P, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.BLOCKING_FACTOR.GET_BLOCKING_FACTOR_DATA, data, onSuccess, onError)
    }

    return {
        getBlockingFactors,
    }
}
